import { api } from "../../shared/api/axios";

export async function fetchResumoInstalacoes() {
  const { data } = await api.get("/instalacoes/resumo");
  return data;
}
